
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderProduct"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderProduct"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"productName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"typePrice"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"quantity"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalPrice"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isContactProduct"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"discountPrice"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isGift"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":149}};
    doc.loc.source = {"body":"fragment OrderProduct on OrderProduct {\n  id\n  productName\n  image\n  typePrice\n  quantity\n  totalPrice\n  isContactProduct\n  discountPrice\n  isGift\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
